module.exports = __webpack_public_path__ + "static/img/five_01.7e98b41.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/AtomicChain/assets/personalIntroduction/five_01.png
// module id = OGko
// module chunks = 3